import { Controller } from "stimulus"
import RequestQueue from '../classes/RequestQueue';
import morphdom from 'morphdom';
import { render } from "preact";
import MitreTable from '../utils/mitre-table';

const PREACT_COMPONENTS_SELECTORS = ['[data-table-target*="stickyCheckbox"]'];
class TableSponsorRowController extends Controller {

  tableIdentifier = 'm-table';
  tableApiIdentifier = 't';

  initialize() {
    const tableKey = this.element.closest('[data-table-key-value]').getAttribute('data-table-key-value');
    this._mitreTable = MitreTable.getByTableKey(tableKey);
  }

  connect() {
    if (this.element.dataset['tableIdentifier']) {
      this.tableIdentifier = this.element.dataset['tableIdentifier'];
    }

    if (this.element.dataset['tableApiIdentifier']) {
      this.tableApiIdentifier = this.element.dataset['tableApiIdentifier'];
    }

    this._handleTableSponsorRowUpdate = (...args) => this._updateRow(...args);

    this._mitreTable.on('table-sponsor-row-update', this._handleTableSponsorRowUpdate);
  }

  disconnect() {
    this._mitreTable.removeListener('table-sponsor-row-update', this._handleTableSponsorRowUpdate);
  }

  unmountComponents(parentNode) {
    PREACT_COMPONENTS_SELECTORS.forEach(selector => {
      parentNode.querySelectorAll(selector).forEach(e => render(null, e.parentNode, e));
    });
  }

  async _updateRow({
    symbol,
    securityType,
    link,
    target,
    hasDisclaimer,
    hasDisclosure,
    disclaimerLogo,
    disclaimerTitle,
    disclaimerText,
    enableDisclaimerHover,
    adUnit,
    hideSponsoredTag
  }) {

    let sponsoredRowElementId = 'mp-table-sponsored-data-row-placeholder-' + adUnit
    let sponsoredRowElement = document.getElementById(sponsoredRowElementId);

    sponsoredRowElement?.classList.remove('t-hidden');

    try {
      let fragment;
      const { currentTabKey, theme, collectionKey } = this._mitreTable.getParams();

      const response = await RequestQueue.addToQueue({
        url: `/api/${this.tableApiIdentifier}/sponsored_row.html/`,
        method: 'post',
        data: {
          symbol: symbol,
          security_type: securityType,
          tab: currentTabKey,
          uuid: this._mitreTable.tableKey,
          theme,

          // Why is it so in here? Why not just the collectionKey from the current table, like on the 2nd line?
          collection: this.__getCollectionFromSecurityType(securityType),
          // collection: collectionKey,

          has_disclaimer: hasDisclaimer,
          has_disclosure: hasDisclosure,
          disclaimer_logo: disclaimerLogo,
          disclaimer_title: disclaimerTitle,
          disclaimer_text: disclaimerText,
          enable_disclaimer_hover: enableDisclaimerHover,
          hide_sponsored_tag: hideSponsoredTag
        }
      });

      const { data } = response;
      const parser = new DOMParser();
      // // create the new element
      fragment = parser.parseFromString(data, 'text/html').body;

      // // get current element
      const prev = sponsoredRowElement;
      // // cleanup preact components
      this.unmountComponents(prev);
      // // render on screen - update the DOM
      const result = morphdom(prev, fragment);
      const dom = morphdom(result, result.firstChild)
      dom.querySelectorAll('a').forEach(el => {
        el.href = link
        el.setAttribute('target', target);
      });
      dom.style.display = '';
      dom.removeAttribute('data-sponsored-row-symbol');
      dom.setAttribute('data-controller', 'sponsor-row-disclaimer');
      dom.id = sponsoredRowElementId;
      sponsoredRowElement?.element?.remove();

      this._mitreTable.emit('table-sponsor-row-update-complete');

    } catch (e) {
      sponsoredRowElement?.classList.add('t-hidden');
    }
  }

  retrieveExistingSponsoredRow = symbol => {
    const existingRow = this.element.closest(`.${this.tableIdentifier}`).querySelector(`[data-sponsored-row-symbol="${symbol}"]`);
    if (existingRow) {
      const existingRowContainer = document.createElement('body');
      existingRowContainer.appendChild(existingRow.cloneNode(true))
      return existingRowContainer;
    }
    return null;
  }

  showDisclaimer() {
    EventManager.emit('sponsor-row-show-disclaimer', {
      disclaimerLogo: this.element.dataset.disclaimerLogo,
      disclaimerTitle: this.element.dataset.disclaimerTitle,
      disclaimerText: this.element.dataset.disclaimerText
    });
  }

  mouseEnterDisclaimer() {
    var sponsoredRow = this;

    this.disclaimerTimeout = setTimeout(function () {
      sponsoredRow.showDisclaimer();
    }, 500);
  }

  mouseLeaveDisclaimer() {
    clearTimeout(this.disclaimerTimeout);
  }

  __getCollectionFromSecurityType(security_type) {
    let sec_type = security_type.toLowerCase();
    switch (sec_type) {
      case "stock":
      case "stocks":
        return "CollectionStocks";
      case "funds":
      case "fund":
        return "CollectionFunds";
      case "etfs":
      case "etf":
        return "CollectionFundsETFOnly";
      default:
        return "CollectionStocks";
    }
  }
}

export default TableSponsorRowController;
